import PropTypes from 'prop-types';
import { getDateLocaleForAgency } from '../../../../helpers/agencyDateFormat';

const DATE_TIME_OPTIONS = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
};

// lastDateToPurchaseUtc is the airline deadline in the agency office's local time (no time zone), so it is
// shown as-is. autoCancellationDeadlineUtc is real UTC, so it is shown in the viewer's time zone.
const HeldFlightDeadlineNote = ({
  lastDateToPurchaseUtc,
  autoCancellationDeadlineUtc,
  travelAgency,
}) => {
  const formatDateTime = (dateTime, options) =>
    new Date(dateTime).toLocaleString(getDateLocaleForAgency(travelAgency), {
      ...DATE_TIME_OPTIONS,
      ...options,
    });

  if (!autoCancellationDeadlineUtc) {
    return (
      <div className="bg-red-600 rounded-md  p-2 text-white">
        <b>Note:</b> Last ticketing date is {formatDateTime(lastDateToPurchaseUtc)}. If payment card
        information is not provided by then, this booking will be automatically cancelled.
      </div>
    );
  }

  return (
    <div className="bg-red-600 rounded-md  p-2 text-white">
      <div>
        <b>
          Automatic cancellation:{' '}
          {formatDateTime(autoCancellationDeadlineUtc, { timeZoneName: 'short' })}
        </b>
      </div>
      <div>Add a payment card before then, or this hold will be cancelled automatically.</div>
      {lastDateToPurchaseUtc && (
        <div className="mt-3">
          <div>
            Airline ticketing deadline: {formatDateTime(lastDateToPurchaseUtc)} (agency office time)
          </div>
          <div>If the airline&apos;s deadline comes first, the airline may cancel the booking.</div>
        </div>
      )}
    </div>
  );
};

HeldFlightDeadlineNote.propTypes = {
  lastDateToPurchaseUtc: PropTypes.string,
  autoCancellationDeadlineUtc: PropTypes.string,
  travelAgency: PropTypes.shape({}),
};

export default HeldFlightDeadlineNote;
